module.exports = __webpack_public_path__ + "static/media/leather_cap.620aa916.png";